import * as actionTypes from './actionType';

export const setAllDataSUCCESS = (payload: any) => (
    console.log(payload, 'payload'),
    {
        type: actionTypes.SET_ALL_SUCCESS,
        payload,
    }
);
export const setAllSelected = (payload: any) => (
    console.log(payload, 'all selected payload'),
    {
        type: actionTypes.SET_ALL_SELECTED,
        payload,
    }
);
export const setAllLightboxDest = (payload: any) => ({
    type: actionTypes.SET_ALL_LIGHTBOXDEST,
    payload,
});
